module.exports = __webpack_public_path__ + "static/media/Path_33961.a0aa4a35.svg";